import { Component, Inject } from '@angular/core';
import { Sensor } from '../../../../model/sensor';
import { TranslateService } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SnackBarService } from '../../../../services/snackBar.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ConfirmationDialogComponent } from '../../../shared/confirmation-dialog/confirmation-dialog.component';
import { Subject, takeUntil } from 'rxjs';

export interface DialogDataConfigSensor {
  sensor: Sensor;
  isLastSensor: boolean;
}

@Component({
    selector: 'app-execution-q-edit-config-sensor',
    templateUrl: './execution-q-edit-config-sensor.component.html',
    styleUrl: './execution-q-edit-config-sensor.component.scss',
    standalone: false,
})
export class ExecutionQEditConfigSensorComponent {
  
  private destroy$ = new Subject<void>();
  
  constructor(
    public dialog: MatDialog,
    private translate: TranslateService,
    private dialogRef: MatDialogRef<ExecutionQEditConfigSensorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataConfigSensor,
    public snackBarService: SnackBarService) { }

  onEvaluateChange(event: MatSlideToggleChange): void {
    this.data.sensor.evaluate = event.checked;

    if (event.checked) {
      const message = this.translate.instant('execution.test.essay.sensor.failed.client') as string;
      
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });
  
      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
        this.data.sensor.validClient = response;
      });
    }
  }

  onOuterChange(event: MatSlideToggleChange): void {
    this.data.sensor.outer = event.checked;
  }

  onOkClick(): void {
    const errs = [];

    const sensor = this.data.sensor;

    if (sensor.location == null || sensor.location === '') {
      errs.push(this.translate.instant('executionEdit.sensorConfig.form.error.location'));
    }

    if (sensor.fromProtocol) {
      if (sensor.evaluate) {
        sensor.evaluateReason = null;
      } else if (sensor.evaluateReason == null || sensor.evaluateReason === '') {
        errs.push(this.translate.instant('executionEdit.sensorConfig.form.error.evaluateReason'));
      }

      if (sensor.location === sensor.locationProtocol) {
        sensor.locationChangeReason = null;
      } else if (sensor.locationChangeReason == null || sensor.locationChangeReason === '') {
        errs.push(this.translate.instant('executionEdit.sensorConfig.form.error.locationReason'));
      }
    } else if (sensor.addingReason == null || sensor.addingReason === '') {
      errs.push(this.translate.instant('executionEdit.sensorConfig.form.error.addingReason'));
    }

    if (errs.length === 0) {
      this.dialogRef.close(sensor);
    } else {
      const error = errs.join('\n');
      this.snackBarService.sendError(error);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

